export const mode = {
  ADD: "ADD",
  EDIT: "EDIT",
  DELETE: "DELETE",
  COPY: "COPY",
};
